import generalSection from "../_section/section.class";
import {userCriticalSkillsEmploymentPermitUpload, adminCriticalSkillsEmploymentPermitUpload} from "./upload";
import DataForm from "./DataForm";

export class userCriticalSkillsEmploymentPermitSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userCriticalSkillsEmploymentPermitUpload);
        // Add missing date error

    }
}

export class adminCriticalSkillsEmploymentPermitSection extends userCriticalSkillsEmploymentPermitSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminCriticalSkillsEmploymentPermitUpload);
        this.DataForm = DataForm
        this.sortByDateProp('expiryDate');
        this.activeUpload = this.uploads.find(u => u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }


    get expiryDate() {
        if (this.activeUpload && this.activeUpload.values.expiryDate) {
            return this.activeUpload.values.expiryDate;
        }
        return null;
    }
    getSectionSummary = () => {
        return [{
            name: `${this.personalTitle}`,
            tags: [
                {
                    name: 'Expiry Date',
                    value: this.activeUpload?.values?.expiryDate?.format('D MMM YYYY') || 'Not Provided',
                }
            ],
        }]
    }
}